<template>
  <div>
    <div class="relative h-[770px]  overflow-hidden">
      <div class="absolute inset-0">
        <img src="../assets/img/bg1.png" alt="背景图片" class="w-full h-full object-cover object-center">
      </div>
      <div class="absolute right-0 top-0 bottom-0 z-1">
        <img src="../assets/img/bg3.png" alt="背景图片" class="h-full wow animate__fadeInRight">
      </div>
      <div class="absolute right-0 top-0 bottom-0 z-1">
        <img src="../assets/img/bg2.png" alt="背景图片" class="h-full wow animate__fadeInRight" data-wow-delay="0.1s">
      </div>
      <div class="relative z-10 container mx-auto w-[1200px] h-[100%]  flex-wrap  flex content-center ">
        <div class="max-w-2xl ">
          <h1 class="text-4xl font-semibold mb-[53px] relative tracking-wide">法智保诉讼保全保函平台
            <img src="../assets/img/bg4.png" class="absolute left-[30px]  w-[220px] bottom-[-17px] z-1" alt="">
          </h1>
          <p class="text-[#606266] text-[16px] mb-[28px] leading-relaxed">
            专业的法院认可电子保函服务平台，为企业提供全方位的诉讼保全服务。我们致力于打造便捷、高效、安全的保函解决方案，实现保全流程的数字化升级。
          </p>

          <div class="grid grid-cols-3 gap-4 mb-8 w-[438px] text-[#606266]">
            <div class="flex items-center p-4 h-[52px] bg-white/60 rounded-lg border-white ">
              <svg class=" w-[20px] h-[20px]" aria-hidden="true">
                <use xlink:href="#icon-Frame-2"></use>
              </svg>
              <span class="pl-[4px]">财产保全保函</span>
            </div>
            <div class="flex items-center p-4  h-[52px] bg-white/60 rounded-lg border-white">
              <svg class=" w-[20px] h-[20px]" aria-hidden="true">
                <use xlink:href="#icon-Frame-4"></use>
              </svg>
              <span class="pl-[4px]">证据保全保函</span>
            </div>
            <div class="flex items-center p-4 h-[52px] bg-white/60 rounded-lg border-white">
              <svg class=" w-[20px] h-[20px]" aria-hidden="true">
                <use xlink:href="#icon-Frame-3"></use>
              </svg>
              <span class="pl-[4px]">行为保全保函</span>
            </div>
            <div class="flex items-center p-4 h-[52px] bg-white/60 rounded-lg border-white">
              <svg class=" w-[20px] h-[20px]" aria-hidden="true">
                <use xlink:href="#icon-Frame-5"></use>
              </svg>
              <span class="pl-[4px]">先予执行保函</span>
            </div>
            <div class="flex items-center p-4  h-[52px] bg-white/60 rounded-lg border-white">
              <svg class=" w-[20px] h-[20px]" aria-hidden="true">
                <use xlink:href="#icon-Frame-1"></use>
              </svg>
              <span class="pl-[4px]">继续保全保函</span>
            </div>
            <div class="flex items-center pl-4  h-[52px] bg-white/60 rounded-lg ">
              <svg class=" w-[23px] h-[23px]" aria-hidden="true">
                <use xlink:href="#icon-Frame"></use>
              </svg>
              <span class="pl-[2px]">解封保全保函</span>
            </div>
          </div>

          <div class="flex items-center space-x-4">
            <a href="https://user.bjfzt.com/#/" target="_blank"> <button
                class="!rounded-button wow animate__bounce apply flex justify-center bg-[#191A1F] text-white w-[126px] leading-[44px]  transition-colors whitespace-nowrap">
                <span class="text-[15px] relaitve z-10 ">立即申请</span>
                <i class="text-[20px] relaitve z-10 icon  leading-[44px] block -rotate-45 ml-3">&#xe6ed;</i>
              </button></a>

            <div @click="push({ path: '/scene' })" class="flex relative more cursor-pointer justify-center items-center">
              <img src="../assets/img/img18.png" class="rounded_c block text-[40px] leading-[40px] w-[40px] h-[40px]"
                alt="">
              <!-- <i class="icon ">&#xe64b;</i> -->
              <i class="fas icon absolute left-[15px] top-[10px] text-[#A11710]">&#xe624;</i>
              <span>了解更多</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  data() {
    return {}
  },
  methods: {},
  mounted() {

    this.$nextTick(() => {
      try {

        new this.$wow.WOW().init();
      } catch (e) {
        console.log(e);
      }
    });

  },
  created() { },
}
</script>
<style scoped lang="less">
.border_c {
  border-left: none;
  border-top: none;
}

.more {
  &:hover {
    .rounded_c {
      transform-origin: center center;
      animation: infinite-rotate 2s linear infinite;
    }
  }
}

@keyframes infinite-rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.apply {
  .icon {
    transition: all 0.5s;
  }

  position: relative;
  overflow: hidden;

  &::after {
    transition: all 0.5s;
    content: "";
    display: block;
    width: 150px;
    height: 150px;
    right: -150px;
    top: 0px;
    position: absolute;
    border-radius: 100%;
    background-color: #A11710;
    z-index: 1;
  }

  &:hover {
    &::after {
      right: -10px;
      top: -50px;
    }

    .icon {
      transform: rotate(0deg)
    }
  }
}
</style>
